/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const TrendDownIconConfig = {
  name: 'TrendDownIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M1024 130.235v405.353c-0.311 14.638-6.224 29.271-16.809 39.858-10.587 10.585-24.907 16.187-39.541 16.498l-46.699 0.002c-14.946 0-29.573-5.915-40.162-16.503-10.585-10.585-16.503-25.221-16.187-39.856l-0.315-182.281-331.95 331.952c-7.767 7.767-19.719 7.767-27.488 0l-139.253-139.255-248.624 248.617-114.75-114.743 349.625-349.63c7.771-7.769 19.723-7.769 27.493 0l133.55 133.55 231.847-230.51-182.75-0.313c-14.638 0.313-29.271-5.605-39.856-16.19-10.585-10.587-16.501-25.221-16.19-39.856v-46.697c0-14.942 5.605-29.266 16.19-39.851 10.585-10.587 25.216-16.503 40.16-16.503h405.353c14.185-0.304 28.066 5.554 38.546 15.554 4.011 2.238 7.065 5.874 8.581 10.306 5.904 9.035 9.23 19.598 9.23 30.496z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
};
export default createIcon(TrendDownIconConfig);
//# sourceMappingURL=trend-down-icon.js.map